import { render, staticRenderFns } from "./CategoryListing.vue?vue&type=template&id=630e45ca&scoped=true"
import script from "./CategoryListing.vue?vue&type=script&lang=js"
export * from "./CategoryListing.vue?vue&type=script&lang=js"
import style0 from "./CategoryListing.vue?vue&type=style&index=0&id=630e45ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630e45ca",
  null
  
)

export default component.exports